export function StoryCallout() {
  return (
    <section className="story-callout">
      <div className="story-stamp">story mode · content becoming lessons</div>
      <p>
        The journal now focuses on the actual message being improved: concise
        work updates, safer examples, everyday small talk, and nonviolent
        communication. The wrapper used to request a correction is no longer
        treated as the learning target.
      </p>
      <blockquote>
        “This sounds abrupt” → “Clarify the observation, name the need, and ask
        for the next action.”
      </blockquote>
      <div className="story-answer">
        Today's loop: notice the content pattern, open Notes, run one drill,
        then reuse the chunk once.
      </div>
    </section>
  );
}
